import { select, takeEvery, put } from 'redux-saga/effects'
import { PRIORITY_CONNECT_SUBMIT_SUCCESS, SET_REDIRECT } from '@actions/types'

const getHash = state => state.auth.hash

/**
 * Redirects the user to the Priority Connect conference after a successful submission.
 * @param action
 */
function * onPriorityConnectSubmitSuccess(action) {
  const conferenceAlias = action.payload.data?.conferenceAlias

  const hash = yield select(getHash)

  const personalAccessCode = hash.substring(0, 10)

  if (conferenceAlias) {
    yield put({
      type: SET_REDIRECT,
      payload: `/${personalAccessCode}/priority-connect/${conferenceAlias}`
    })
  }
}

/**
 * Root saga that watches for panic button / Priority Connect actions.
 */
function * watchInitialize() {
  yield takeEvery(PRIORITY_CONNECT_SUBMIT_SUCCESS, onPriorityConnectSubmitSuccess)
}

export default watchInitialize
